import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";
import styles from "../../styles/components/organisms/List.module.scss";

interface ListProps {
  className?: string;
  children?: any;
  sortable?: boolean;
  maxItems?: number;
  data?: any;
  forwardedRef?: any;
}

export default function List(props: ListProps) {
  const { list } = styles;
  const { maxItems, className, children, forwardedRef } = props;
  const listRef = useRef() as any;
  const classes = clsx(
    list,
    "offset",
    "list",
    { [styles.fade]: !!maxItems && children.length > maxItems },
    className
  );

  useEffect(() => {
    let timeout: any;
    const onResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const lis = Array.from(listRef.current.children).slice(0, maxItems);
        const h = lis.reduce(
          (acc: number, curr: any) => acc + curr.offsetHeight,
          0
        );
        listRef.current.style = `max-height: ${h}px;`;
      }, 1000);
    };

    if (!!maxItems) {
      onResize();
      window.addEventListener("resize", onResize);
    }

    return () => {
      clearTimeout(timeout);
      if (!!maxItems) {
        window.removeEventListener("resize", onResize);
      }
    };
  }, [maxItems]);

  return (
    <div className={classes} ref={forwardedRef}>
      <ul ref={listRef}>
        {children.map((child: React.ReactElement, i: number) => (
          <li key={i}>{child}</li>
        ))}
      </ul>
    </div>
  );
}
